import styled from "styled-components";
import { Link } from "react-router-dom";

const TextLink = styled(Link).attrs({
  className: "text-secondary"
})`
  font-size: 12px;
  font-weight: 300;
`;

export { TextLink };



// WEBPACK FOOTER //
// ./src/components/TextLink.js